import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(timezone);
function nextWeekday(weekday) {
  const day = dayjs(new Date());
  const current = day.day();
  const days = (7 + weekday - current) % 7;
  return day.clone().add(days, "d").format("YYYY-MM-DDTHH:mm:ss").toString();
}

function to12HoursFormat(hourInUTC, onlyHaveUTCHour = false, day = 1) {
  if (onlyHaveUTCHour) {
    const auxDate = nextWeekday(day);
    const d = auxDate.split("T");
    return dayjs(`${d[0]}T${hourInUTC}Z`).format("h:mm A");
  }
  return dayjs(hourInUTC).format("h:mm A");
}

export default to12HoursFormat;
